module.exports = __webpack_public_path__ + "static/media/16UNODC24.c22bac45.jpg";